import SectionHeader from './SectionHeader';

const CASES = [
  {
    id: 'case-a',
    tag: '内容特征型',
    severity: '下架',
    title: '画面「安全」、引导擦边的穿搭号',
    summary: '画面本身没暴露，但机位与动作摆拍反复制造「下一秒会越界」的强暗示，被按行为引导判定。',
    steps: ['连续多条被打上「疑似低俗」标签', '限流后仍未调整，进入人工复核', '判定引导性违规，批量下架'],
    img: 'https://readdy.ai/api/search-image?query=flat%20lay%20of%20a%20fashion%20review%20workspace%20with%20a%20red%20review%20stamp%2C%20smartphone%2C%20ruler%20and%20folded%20fabric%20on%20warm%20cream%20desk%2C%20editorial%20product%20photography%2C%20warm%20natural%20light%2C%20minimal%20composition&width=800&height=520&seq=51c-case-a&orientation=landscape',
  },
  {
    id: 'case-b',
    tag: '话术诱导型',
    severity: '限流→整改',
    title: '标题用谐音绕关键词的搬运号',
    summary: '正文反复用谐音缩写表达违规词，规避初审成功，却在二次人工复核时被连坐处理。',
    steps: ['机器初审漏过，成功进入推荐池', '互动举报触发人工复核', '话术整体定性，限流并要求整改'],
    img: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20magnifying%20glass%20over%20dense%20black%20text%20lines%20on%20paper%2C%20editorial%20review%20theme%2C%20red%20highlight%20marks%2C%20warm%20desk%20lighting%2C%20documentary%20photography%20style&width=800&height=520&seq=51c-case-b&orientation=landscape',
  },
  {
    id: 'case-c',
    tag: '直播行为型',
    severity: '封禁',
    title: '连麦互动往越线方向带节奏',
    summary: '静态展示合规，直播过程通过连麦话术与观众高频互动「往上带」，被判定为行为型严重违规。',
    steps: ['直播监控命中高风险行为', '账号此前已有一次整改记录', '累计升级为封禁处置'],
    img: 'https://readdy.ai/api/search-image?query=overhead%20view%20of%20a%20live%20streaming%20control%20desk%20with%20two%20phones%20and%20red%20warning%20tape%2C%20editorial%20concept%20of%20content%20monitoring%2C%20warm%20tones%2C%20clean%20studio%20lighting&width=800&height=520&seq=51c-case-c&orientation=landscape',
  },
  {
    id: 'case-d',
    tag: '语境判定型',
    severity: '下架',
    title: '封面 + 简介组合触发未成年人保护',
    summary: '内容本身未必越线，但封面的引导性与账号推流人群叠加，触发了「未成年人可见」高危逻辑。',
    steps: ['推流渠道触达未成年用户群体', '封面组合被判定强引导', '因保护逻辑直接下架'],
    img: 'https://readdy.ai/api/search-image?query=minimal%20editorial%20illustration%20of%20a%20shield%20and%20phone%20notification%20icon%2C%20cream%20and%20vermilion%20red%20palette%2C%20flat%20clean%20vector%20style%2C%20content%20safety%20concept%2C%20soft%20paper%20texture%20background&width=800&height=520&seq=51c-case-d&orientation=landscape',
  },
];

export default function ViolationCases() {
  return (
    <section id="cases" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <SectionHeader
            eyebrow="51擦边 · 违规案例"
            title="四条典型「翻车」链路复盘"
            desc="每个案例都不是孤例，背后对应一种常见的违规判定逻辑。看它们不是为复刻，而是想清楚哪里先亮红灯。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap self-start rounded-full border border-secondary-200 bg-secondary-50 px-4 py-2 text-sm font-semibold text-secondary-800 md:self-auto">
            <i className="ri-eye-line" />
            案例已脱敏整理
          </span>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {CASES.map((c) => (
            <article key={c.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 sm:flex-row">
              <div className="relative h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-48 lg:w-52">
                <img
                  src={c.img}
                  alt={`${c.title} 违规复盘`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/80 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-error-warning-line text-accent-300" />
                  {c.severity}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-bold tracking-widest text-accent-600">{c.tag}</span>
                  <i className="ri-arrow-right-up-line text-background-300 transition-colors group-hover:text-primary-500" />
                </div>
                <h3 className="mt-1.5 font-serif text-base font-bold text-foreground-950 md:text-lg">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.summary}</p>
                <ol className="mt-3 flex flex-1 flex-col justify-end gap-1.5 border-t border-background-200 pt-3">
                  {c.steps.map((s, i) => (
                    <li key={s} className="flex items-start gap-2 text-xs text-foreground-700">
                      <span className="mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary-500/10 text-[10px] font-bold text-primary-600">
                        {i + 1}
                      </span>
                      {s}
                    </li>
                  ))}
                </ol>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}